import React from 'react';

import styles from './index.module.scss';

import logo_url from '../../assets/images/logo.png';
import logo_url_full from '../../assets/images/logo-quiz.png';

interface LogoProps {
  type?: 'default' | 'simple' | 'full';
}

const Logo: React.FC<LogoProps> = ( { type = 'default' } ) => {

  return (
    <span className={`${styles.Logo} ${type === 'full' ? styles.LogoFull : ''}`}>
      <img src={type === 'full' ? logo_url_full : logo_url} alt="Friends 2026 Logo" />
      {type === 'default' && <span>QUIZ</span>}
    </span>
  );
};

export default Logo; 